// extracted by mini-css-extract-plugin
module.exports = {"ldsDualRing":"Spinner_ldsDualRing__2242Q","lds-dual-ring":"Spinner_lds-dual-ring__2ox2o"};